import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const SetupTopNav = () => {
	return (
		<div className="topNav setupTopNav">
			<div className="setupTopNavInner">
				<Link className="blueLink" to="/app/">
					<Button className="setupBackBtn">
						<span className="glyphicon glyphicon-arrow-left leftGlyph"></span>
						Back to app
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default SetupTopNav;
